import { logout } from "shared/firebase/auth";
import { AsyncButton, Icon, NOTICES, Page, PathButton } from "shared/react";
import { CreatorMenu } from "../create/CreatorMenu.js";
import { ProfilePhoto } from "../entity/EntityPhoto.js";
import { SettingsMenu } from "../settings/SettingsMenu.js";
import { useProfileItem } from "../util/data.js";
import { USER } from "../util/user.js";

export function MenuPage(): React.ReactElement {
	const { username, verified } = useProfileItem().data;
	return (
		<Page title="Menu">
			<header className="panel pad-none fill-yellow">
				<div>
					<img src="/img/icon.svg" className="icon size-3x" alt="Trajectory" title="Trajectory" />
				</div>
				<div className="pin-top pin-right pin-bottom flex-row">
					<PathButton mods="fill-yellow" path="/search/profiles" title="Search">
						<Icon icon="search" />
					</PathButton>
					<PathButton mods="fill-yellow" path="/settings" title="Settings">
						<Icon icon="settings" />
					</PathButton>
				</div>
			</header>
			<nav className="flex-column gap-hairline">
				<h2 className="label">Challenges</h2>
				<PathButton path="/challenges/active">
					<Icon icon="challenge" /> <span>Active challenges</span>
				</PathButton>
				<PathButton path="/challenges/completed">
					<Icon icon="tick" /> <span>Completed challenges</span>
				</PathButton>
				<PathButton path="/topic/explore">
					<Icon icon="hash" /> <span>Explore challenges</span>
				</PathButton>
			</nav>
			<nav className="flex-column gap-hairline">
				<h2 className="label">Posts</h2>
				<PathButton path="/posts">
					<Icon icon="post" /> <span>Posts</span>
				</PathButton>
				<PathButton path="/posts/new">
					<Icon icon="add" /> <span>Create post</span>
				</PathButton>
			</nav>
			<nav className="flex-column gap-hairline">
				<h2 className="label">Profile</h2>
				<PathButton path={`/${username}`}>
					<ProfilePhoto uid={USER.data.uid} /> <span>My profile</span>
				</PathButton>
				<PathButton path={`/${username}/earned/badges`}>
					<Icon icon="badge" /> <span>Earned badges</span>
				</PathButton>
			</nav>
			<nav className="flex-column gap-hairline">
				<h2 className="label">Groups</h2>
				<PathButton path="/groups">
					<Icon icon="chat" /> <span>My groups</span>
				</PathButton>
				<PathButton path="/groups/invites">
					<Icon icon="add" /> <span>Group invites</span>
				</PathButton>
				<PathButton path="/groups/new">
					<Icon icon="add" /> <span>Create group</span>
				</PathButton>
			</nav>
			<CreatorMenu path={`/${username}`} verified={verified} />
			<SettingsMenu />
			<nav>
				<AsyncButton
					onClick={async () => {
						await logout();
						NOTICES.success("See you soon!");
					}}
				>
					<Icon icon="left" /> <span>Logout</span>
				</AsyncButton>
			</nav>
		</Page>
	);
}
